// Build full CDN URLs from relative paths (e.g., "users/9/avatar_...webp").
// Works across Vue CLI (process.env.VUE_APP_*) and falls back safely.

function readImagesBase() {
  // Prefer Vue CLI env (webpack replaces process.env.* at build time)
  try {
    if (typeof process !== 'undefined' && process?.env?.VUE_APP_IMAGES_BASE_URL) {
      return process.env.VUE_APP_IMAGES_BASE_URL;
    }
  } catch (_) { /* noop */ }
  // Final fallback (your CDN host)
  return 'https://images.snexus.co';
}

const RAW_BASE = readImagesBase();
const CDN_BASE = String(RAW_BASE || '').replace(/\/+$/, ''); // strip trailing '/'

const ABSOLUTE_RE = /^(?:[a-z]+:)?\/\//i; // http(s):// or protocol-relative
const SPECIAL_RE = /^(data:|blob:)/i;

/**
 * Return a full CDN URL for a given path.
 * - If given an absolute URL (http/https), or data:/blob:, returns as-is.
 * - If given a relative path, joins with CDN_BASE.
 */
export function cdnUrl(relOrAbs) {
  if (!relOrAbs) return '';
  const s = String(relOrAbs);
  if (ABSOLUTE_RE.test(s) || SPECIAL_RE.test(s)) return s;
  const path = s.replace(/^\/+/, ''); // remove leading slashes
  return `${CDN_BASE}/${path}`;
}

/** Convenience: from a profile object that has `image` (relative path). */
export function avatarUrlFromProfile(profile) {
  if (!profile || !profile.image) return '';
  return cdnUrl(profile.image);
}

export { CDN_BASE };
